import React from 'react';
import { motion } from 'framer-motion';
import { MockupBook } from '../ui/MockupBook';
export function Bonus() {
  const bonuses = [{
    icon: '🎵',
    num: 1,
    title: 'Cancionero & Guía de Sonido',
    desc: 'Mantras, playlists y música para cada momento de tu clase.',
    color: 'salvia'
  }, {
    icon: '🗓️',
    num: 2,
    title: 'Arquitecto de Talleres',
    desc: 'Diseñá y vendé talleres y retiros con cronogramas y costos resueltos.',
    color: 'dorado'
  }, {
    icon: '📱',
    num: 3,
    title: 'Yoga Business & Instagram',
    desc: 'El sistema para llenar tus clases usando Meta y WhatsApp.',
    color: 'oscuro'
  }, {
    icon: '🗣️',
    num: 4,
    title: 'Master de Ajustes Verbales',
    desc: 'Scripts palabra por palabra para corregir alineación sin tocar.',
    color: 'terracota'
  }, {
    icon: '🧱',
    num: 5,
    title: 'Prop Master',
    desc: 'Uso experto de bloques, correas y sillas para cualquier nivel.',
    color: 'salvia'
  }, {
    icon: '🦴',
    num: 6,
    title: 'Anatomía Aplicada',
    desc: 'Mapa muscular de las 20 posturas más usadas. Prevención de lesiones.',
    color: 'dorado'
  }] as const;
  return <section className="py-20 px-4 max-w-6xl mx-auto" data-id="element-34">
      <div className="text-center mb-16" data-id="element-35">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-oscuro mb-4" data-id="element-36">
          + 6 Regalos Estratégicos
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-gray-600 font-medium mb-6" data-id="element-37">
          Incluidos sin costo extra · Valor real del pack
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="inline-block bg-terracota text-white font-bold px-6 py-2 rounded-full shadow-md" data-id="element-38">
          🎁 GRATIS POR EL DÍA DE HOY
        </motion.div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-39">
        {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-white p-6 md:p-8 rounded-2xl shadow-soft border border-gray-100 flex flex-col sm:flex-row items-center sm:items-start gap-6" data-id="element-40">
            <div className="flex-shrink-0" data-id="element-41">
              <MockupBook title={`Bonus ${bonus.num}`} color={bonus.color} size="sm" icon={<span className="text-2xl" data-id="element-43">{bonus.icon}</span>} data-id="element-42" />
            </div>
            <div className="flex-1 text-center sm:text-left" data-id="element-44">
              <div className="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full mb-3" data-id="element-45">
                GRATIS
              </div>
              <h3 className="text-xl font-bold text-oscuro mb-2 flex items-center justify-center sm:justify-start gap-2" data-id="element-46">
                {bonus.icon} Bonus {bonus.num} — {titleSplit(bonus.title)[0]}
                <br className="hidden sm:block lg:hidden" data-id="element-47" />
                {titleSplit(bonus.title)[1]}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-48">{bonus.desc}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}
// Helper to split long titles if needed, though we can just render it directly
function titleSplit(title: string) {
  return [title, ''];
}